__turbopack_context__.v({
  "bounce_circleG": "homesearchresults-module__u_a0Va__bounce_circleG",
  "circleG": "homesearchresults-module__u_a0Va__circleG",
  "circleG1": "homesearchresults-module__u_a0Va__circleG1",
  "circleG2": "homesearchresults-module__u_a0Va__circleG2",
  "circleG3": "homesearchresults-module__u_a0Va__circleG3",
  "loadingthumbnail": "homesearchresults-module__u_a0Va__loadingthumbnail",
});
